import React from 'react'

export const MagnifierDarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
    <path
      d="M15 15.3491L11.6556 12.0047M13.4444 7.57134C13.4444 11.0078 10.6587 13.7936 7.22222 13.7936C3.78578 13.7936 1 11.0078 1 7.57134C1 4.1349 3.78578 1.34912 7.22222 1.34912C10.6587 1.34912 13.4444 4.1349 13.4444 7.57134Z"
      stroke="#292624"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
